<template>
<div>
  <br>
  <br>
  <!-- Video header -->
  <section>
    <b-container>
      <div class="logo-video-container">
        <video id="vid" autoplay :src="publicPath+'/videos/bgvid.mp4'" type="video/mp4" loop muted playsinline></video>
        <div class="logo-wrap">
          <b-img class="logo" :class="{active: isLogoVisible}" fluid src="../assets/elearning/ELearningLogo.svg"></b-img>
        </div>

      </div>


  <!-- Intro text -->
      <br>
      <h3>WHIN provides broadband solutions to students</h3>
      <br>
      <p>
        The Wabash Heartland Innovation Network (WHIN) has allocated $2M to the school corporations in the ten-county WHIN region to provide broadband solutions for students who do not have adequate access to the internet for schoolwork.
        <br><br>

        The allocation is the first of a 3-year, $6 million project to improve student connectivity in the region.  North Central Health Services is a partner in the initiative.
      </p>

      <b-row>
        <b-col>
          <div class="text-center">
            <b-button href="mailto:pat@whin.org"  variant="primary" class="m-2">Learn More</b-button>
<!--            <b-button variant="outline-primary" class="m-2">Member Login</b-button>-->

          </div>
        </b-col>
      </b-row>

    </b-container>
  </section>

  <!-- Region animation -->
  <section>
    <CountySchoolDistrictAnimation/>
  </section>

  <!-- Indiana region text and image -->
  <section>
    <b-container>
      <b-row>
        <b-col>
          <p class="indiana-counties-text">
          Schools may use their allocations to provide plans to students that are compatible with their school-issued Chromebooks and iPads.  In the short run, that can include personal hotspots.  The funding is also available for teachers who do not have adequate access to prepare and conduct lessons from home. WHIN’s long term broadband strategy includes helping school corporations find more permanent, network-based solutions.
          </p>
        </b-col>
        <b-col>
          <b-img class="indiana-counties" src="@/assets/elearning/RegionInIndianaContext.svg"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </section>

<!-- School corporation logos -->
  <section>

    <b-container>
      <h4 class="logos-header">School Corporation Partners</h4>
      <b-row>
        <b-col class="school-logo-wrap"  v-for="logo in logos" :key="logo.name">
          <b-img :src="publicPath+'/img/schoolcorps/'+logo.img" class="school-logo"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </section>

  <!-- Call to action repeat -->
  <section>
    <div class="text-center">
      <b-button href="mailto:pat@whin.org"  variant="primary" class="m-2">Learn More</b-button>
<!--      <b-button variant="outline-primary" class="m-2">Member Login</b-button>-->

    </div>
  </section>


  <!-- Thanks to section -->
  <section>

    <b-container>
      <b-row>
        <b-col cols="5" md="3">

          <b-img src="@/assets/elearning/NCHSLogo@3x.png" class="nchs float-left"></b-img>
        </b-col>
        <b-col cols="7" md="4">
          <p class="nchs-text">A special thank you to North Central Health Services, WHIN’s partner in the E.Learning Initiative. </p>

        </b-col>
      </b-row>
    </b-container>
  </section>


  <!-- Placeholder for footer -->
  <div style="min-height: 250px;"></div>

</div>
</template>

<script>

import "@/assets/fonts/stylesheet.css"
import CountySchoolDistrictAnimation from "@/components/CountySchoolDistrictAnimation";

const schoolLogos = [
  {name: "Attica Consolidated Schools", img: "Attica_ConsolidatedSchools_Logo.png"},
  {name: "Benton Community Schools", img: "Benton Community Schools.png"},
  {name: "Carroll Consolidated", img: "Carroll Consolidated Logo.png"},
  {name: "Caston Schools Corp", img: "Caston_SchoolsCorp_Logo.png"},
  {name: "Clinton Central Schools", img: "ClintonCentral_Schools_Logo.png"},
  {name: "Clinton Prairie Schools", img: "ClintonPrairie_Schools_Logo.png"},
  {name: "Community Schools of Frankfort", img: "CommunitySchoolsofFrankfort_Logo.png"},
  //{name: "Covington Christian School", img: "CovingtonChristian_School_Logo.png"},
  {name: "Covington Community Schools", img: "CovingtonCommunity_Schools_Logo.png"},
  {name: "Crawfordsville Community Schools", img: "CrawfordsvilleCommunity_Schools_Logo.png"},
  {name: "Culver Community Schools", img: "CulverCommunity_Schools_Logo.png"},
  {name: "Delphi Community Schools", img: "Delphi_CommunitySchools_Logo.png"},
  //{name: "Diocese of Lafayette", img: "Diocese of Lafayette Logo.png"},
  {name: "Eastern Pulaski Community Schools", img: "EasternPulaskiCommunity_Schools_Logo2.png"},
  //{name: "Faith Christian School", img: "FaithChristian_School_Logo.png"},
  {name: "Frontier Schools", img: "Frontier_Schools_Logo.png"},
  //{name: "Lafayette Christian School", img: "LafayetteChristian_School_Logo.png"},
  {name: "Lafayette Schools", img: "Lafayette_Schools_Logo.jpg"},
  {name: "Lewis Cass School", img: "LewisCass_School_Logo.png"},
  {name: "Logansport Community Schools", img: "Logansport_CommunitySchools_Logo.png"},
  {name: "MSD Warrent Co School", img: "MSDWarrentCo_School_Logo.png"},
  {name: "North Judson San-Pierre Schools", img: "NorthJudsonSan-Pierre_Schools_Logo.png"},
  {name: "North Montgomery Schools", img: "NorthMontgomery_Schools_Logo.png"},
  {name: "North White Schools", img: "NorthWhite_Schools_Logo.png"},
  {name: "Pioneer Regional Schools", img: "Pioneer_RegionalSchools_Logo.png"},
  {name: "Rossville Consolidated Schools", img: "RossvilleConsolidated_Schools_Logo.png"},
  {name: "South Montgomery Schools", img: "SouthMontgomery_Schools_Logo.png"},
  {name: "Southeast Fountain Schools", img: "SoutheastFountain_Schools_Logo.png"},
  //{name: "St. James Lutheran School", img: "StJamesLutheran_School_Logo.png"},
  {name: "TC Harris School", img: "TCHarris_School_Logo.jpg"},
  {name: "Tippecanoe Schools", img: "Tippecanoe_Schools_Logo.png"},
  {name: "TriCounty Schools", img: "TriCounty_Schools_Logo.png"},
  {name: "Twin Lakes Schools", img: "TwinLakes_Schools_Logo.png"},
  {name: "West Central Schools", img: "WestCentral_Schools_Logo.png"},
  {name: "West Lafayette Schools", img: "WestLafayette_Schools_Logo.png"},
];

export default {

  name: "ELearningPage",
  components: {CountySchoolDistrictAnimation},
  data: function() {
    const publicPath = (process.env.BASE_URL !== '/')?process.env.BASE_URL: '';

    return {
      // for video URL
      publicPath: publicPath,

      isLogoVisible: false,
      logos: schoolLogos
    }
  },
  mounted() {
    // Show the main logo over the video after a couple seconds
    const vid = document.getElementById("vid");
    vid.addEventListener("timeupdate", () => {
      if (vid.currentTime >= 2.0) {
        this.isLogoVisible = true;
      }
    });
  },
  methods: {

  },
  computed: {

  }
}

</script>

<style lang="scss" scoped>
  section {
    margin-top: 8rem;
    text-align: left;
  }
  section:first-of-type {
    margin-top: 0;
  }

  video {
    width: 100%;
  }
  .logo-video-container {
    position: relative;

  }
  .logo-wrap {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .logo {
    max-width: 33%;
    margin-top: 10%;
    opacity: 0;
    transition: opacity 1.5s ease-in-out;
  }
  .logo.active {
    opacity: 1.0;
  }
  .logo.fade {
    opacity: 0;
  }


  h3 {
    color: #808285;
    font-size: 175%;
    font-family: 'Aero Matics', sans-serif;
    font-weight: 400;
  }
  p {
    font-family: "Aaux ProRegular", sans-serif;
    font-size: 125%;
  }


  /* Indiana counties */
  .indiana-counties-text {

      font-size: 125%;
      text-align: right;
      color: #58595B;
  }
  @media (min-width: 768px) {
    .indiana-counties-text {
      font-size: 125%;
    }
  }
  /* A little bit bigger and pulled over center line on desktop */
  @media (min-width: 1000px) {
    .indiana-counties-text {
      font-size: 150%;
      line-height: 180%;
      font-family: "Aaux ProLight", sans-serif;
      margin-right: -2.5rem;
    }

  }

  .indiana-counties {
    max-width: 350px;
  }

  .logos-header {
    font-family: "Aero Matics Light", sans-serif;
    font-size: 175%;
    color: #808285;
    text-transform: uppercase;
  }

  .school-logo-wrap {
    text-align: center;
  }
  .school-logo {
    margin: .5rem;

    height: 50px;
    filter: saturate(0%);
  }

  .nchs {
    max-width: 100%;
  }
  .nchs-text {
    color: #808285;
  }

</style>